<template lang="pug">
	.has-text-centered
		h1.title {{ name }}
		h2.subtitle(v-if="subtitle") {{ subtitle }}
</template>

<script>
export default {
	props: {
		name: {
			type: String,
			required: true
		},
		subtitle: {
			type: String,
			required: false
		}
  }
}
</script>

<style lang="stylus" scoped>
	h1
		margin-top 1rem
		margin-bottom 2rem
		text-transform uppercase
</style>
